import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
const secretKey = "MySuperSecretKey"; // 16 chars
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
const base = BigInt(alphabet.length);

@Injectable({
  providedIn: 'root'
})
export class AesEncryptionService {

  /**
   * Encrypt plain text using AES/ECB/PKCS5Padding
   */
encryptTicket(ticket: string): string {
    // 1️⃣ AES encrypt with ECB + PKCS7 (equivalent to PKCS5)
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(ticket),
        key,
        { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    );

    // 2️⃣ Convert Base64 ciphertext to hex
    const hexStr = CryptoJS.enc.Base64.parse(encrypted.toString()).toString(CryptoJS.enc.Hex);

    // 3️⃣ Convert hex string to BigInt (same as Kotlin BigInteger)
    let number = BigInt("0x" + hexStr);

    // 4️⃣ Encode BigInt to Base32-like string using your alphabet
    let base32Str = "";
    if (number === 0n) return alphabet[0];

    while (number > 0) {
        const index = Number(number % base);
        base32Str = alphabet[index] + base32Str;
        number = number / base;
    }

    return base32Str;
}
  /**
   * Decrypt Base64 AES string from backend
   */
  decrypt(cipherText: string): string {
    const key = CryptoJS.enc.Utf8.parse(secretKey);

    const decrypted = CryptoJS.AES.decrypt(
      cipherText,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
